import { USER_DETAILS_KEY } from "../../config/eventHandlers";
import { getFormName, BENEF_MAP } from "./constants/constants";

export const sleep = (time) => new Promise((acc) => setTimeout(acc, time));

export const getUserDetails = (key) => {
  try {
    if (localStorage) {
      const userDetailsString = localStorage.getItem(USER_DETAILS_KEY);
      // if no user details present return null
      if (!userDetailsString) return null;
      const userDetails = JSON.parse(userDetailsString);
      if (key in userDetails) return userDetails[key];
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getBillCategories = (relationId = BENEF_MAP.SELF) => {
  let benefMappedServices = [], allowedServices = [], billCategory = {};
  try {
    if (localStorage) benefMappedServices = localStorage.getItem("benefMappedServices");
    if (benefMappedServices) benefMappedServices = JSON.parse(benefMappedServices);
    // pick categories based on selected relationId, default to BENEF_MAP.SELF (Self)
    allowedServices = (benefMappedServices && benefMappedServices[relationId]) || [];
    for (let service of allowedServices) {
      let key = service.category;
      let value = getFormName(key);
      billCategory[value] = { key, value }
    }

    return billCategory;
  } catch (error) {
    console.error("Error parsing benefMappedServices:", error);
  }
}

export const isMobile = (innerWidth = window.innerWidth) => {
  return innerWidth <= 576 
}

export const handleBannerClick = (token, accessToken) => (callback) => (url, page, serviceName, altText) => {
  const processedUrl = url.includes("{{short_token}}")
    ? url.replace("{{short_token}}", token)
    : url.replace("{{long_token}}", accessToken);

  callback(processedUrl, page, serviceName, altText);
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export const getClaimDisplayStatus = (claimRemarks, statusMismatch) => {
  if (
    statusMismatch ||
    ["pre approved", "pre rejected", "partially pre approved", "recheck"].includes(
      claimRemarks?.toLowerCase()
    )
  ) {
    return "Under Process";
  }
  return claimRemarks;
};

export const formatTimelineDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    const time = date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
    return `${day}-${month}-${year}, ${time}`;
  };

export const TimelineResponseStatusMap = {
    "submitted": "Claim Submitted",
    "pre approved":"Under Process",
    "pre rejected":"Under Process",
    "partially pre approved":"Under Process",
    "information required": "Information Required",
    "resubmitted": "Claim Resubmitted",
    "approved": "Approved",
    "partially approved": "Partially Approved",
    "rejected": "Rejected",
    "raised for payment": "Raised For Payment",
    "payment settled": "Payment Settled",
  };

  export const ADVANCED_BILL_STATUSES = [
  "approved",
  "rejected",
  "partially approved",
  "ir updated"
];

export const getMasFiscalYear = (selectedPolicy) => {
  if (!selectedPolicy) return "25-26";
  
  const policyName = selectedPolicy?.policyPeriodLabel || selectedPolicy?.policyName || "";
  
  if (policyName.includes("Wipro MAS Benefits")) {
    return "26-27";
  }
  
  return "25-26";
};
